/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "components/sidebar";
import routes from "routes";
import { usePermissions } from "hooks/usePermissions";

export default function SuperUser(props: { [x: string]: any }) {
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Dashboard");
  const { hasPermission } = usePermissions();

  const defaultRoute = React.useMemo(() => {
    for (const r of routes) {
      if (r.layout === "/superuser") {
        if (!r.children || r.children.length === 0) {
          if (r.sidebar && (!r.module || hasPermission(r.module, "READ"))) {
            if (r.path) return `/superuser/${r.path}`;
          }
        } else {
          for (const child of r.children) {
            if (child.sidebar && (!child.module || hasPermission(child.module, "READ"))) {
              if (child.path) return `/superuser/${child.path}`;
            }
          }
        }
      }
    }
    return "/superuser/dashboard";
  }, [hasPermission]);

  React.useEffect(() => {
    const handleResize = () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes: any[]): string | boolean => {
    let activeRoute = "Dashboard";

    const findActiveRoute = (nestedRoutes: any[]) => {
      for (let i = 0; i < nestedRoutes.length; i++) {
        const splitPath = location.pathname.split("/");

        if (splitPath.includes(nestedRoutes[i].path)) {
          setCurrentRoute(nestedRoutes[i].name);
          activeRoute = nestedRoutes[i].name;
        }

        if (nestedRoutes[i].children) {
          findActiveRoute(nestedRoutes[i].children);
        }
      }
    };

    findActiveRoute(routes);

    return activeRoute;
  };
  const getRoutes = (routes: any[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/superuser") {
        if (!prop.children || prop.children.length === 0) {
          // Handle routes without children
          return (
            <Route path={prop.path} element={prop.component} key={key} />
          );
        } else {
          // Handle routes with children
          return prop.children.map((childProp: any, childKey: number) => {
            return (
              <Route
                path={childProp.path}
                element={childProp.component}
                key={`${key}-${childKey}`}
              />
            );
          });
        }
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex min-h-screen w-full">
      <Sidebar
        open={open}
        handleClick={open ? () => setOpen(false) : () => setOpen(true)}
      />
      {/* Navbar & Main Content */}
      <div className="min-h-screen w-full bg-lightPrimary dark:!bg-navy-900">
        <main
          className={`flex-none transition-all duration-300 ease-in-out ${
            open ? "ml-[260px]" : "ml-[70px]"
          }`}
        >
          {/* Routes */}
          <div className={location.pathname.includes('dashboard') ? '' : 'h-screen overflow-hidden'}>
            <div className={`mx-auto ${location.pathname.includes('dashboard') ? 'mb-auto min-h-screen' : location.pathname.includes('device') ? 'h-full pb-5 pt-0' : 'h-full px-6 pb-5 pt-0'}`}>
              <Suspense fallback={<div />}>
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to={defaultRoute} replace />}
                  />
                </Routes>
              </Suspense>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
